import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "edit-tenant"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.57 5.93018L3.5 12.0002L9.57 18.0702M20.5 12.0002H3.67",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Voltar", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "photo" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", null, "Logo do tenant", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "tooltip",
  for: "tenant-logo"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M23 19C23 19.5304 22.7893 20.0391 22.4142 20.4142C22.0391 20.7893 21.5304 21 21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H7L9 3H15L17 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V19Z",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "A logo é exibida no menu do tenant para os usuários daquela conta.", -1)
const _hoisted_10 = { class: "double" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Nome"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Sigla")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Setor"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_14 = ["onMousedown"]
const _hoisted_15 = { class: "spacing" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Módulos")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h2", null, "Controle quais funcionalidades pagas este tenant tem acesso.", -1)
const _hoisted_18 = { class: "modules" }
const _hoisted_19 = ["checked", "onChange"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_21 = { class: "spacing roles-section" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Perfis de acesso")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h2", null, "Gerencie os perfis deste tenant e as permissões de cada um.", -1)
const _hoisted_24 = {
  key: 0,
  class: "roles-list"
}
const _hoisted_25 = {
  key: 0,
  class: "role-summary"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "22",
    height: "22",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "none",
      d: "M13.2594 3.59924L5.04936 12.2892C4.73936 12.6192 4.43936 13.2692 4.37936 13.7192L4.00936 16.9592C3.87936 18.1292 4.71936 18.9292 5.87936 18.7292L9.09936 18.1792C9.54936 18.0992 10.1794 17.7692 10.4894 17.4292L18.6994 8.73924C20.1194 7.23924 20.7594 5.52924 18.5494 3.43924C16.3494 1.36924 14.6794 2.09924 13.2594 3.59924Z",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11.89 5.05078C12.0996 6.39164 12.7486 7.62492 13.735 8.55703C14.7214 9.48914 15.9894 10.0673 17.34 10.2008M3 22.0008H21",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "permissions-grid" }
const _hoisted_30 = ["checked", "onChange"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_32 = { class: "role-actions" }
const _hoisted_33 = ["disabled", "onClick"]
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "add-role" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h2", null, "Criar novo perfil", -1)
const _hoisted_37 = { class: "permissions-grid" }
const _hoisted_38 = ["checked", "onChange"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { class: "spacing users-section" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Usuários")
], -1)
const _hoisted_43 = {
  key: 0,
  class: "users-list"
}
const _hoisted_44 = { class: "title" }
const _hoisted_45 = { class: "actions" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "22",
    height: "22",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M17.4417 14.62L20.0017 12.06L17.4417 9.5M9.76172 12.06H19.9317M11.7617 20C7.34172 20 3.76172 17 3.76172 12C3.76172 7 7.34172 4 11.7617 4",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { class: "add-user" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("h2", null, "Adicionar usuário", -1)
const _hoisted_52 = { class: "double" }
const _hoisted_53 = { class: "double" }
const _hoisted_54 = { class: "double" }
const _hoisted_55 = ["onMousedown"]
const _hoisted_56 = ["onMousedown"]
const _hoisted_57 = ["disabled"]
const _hoisted_58 = ["disabled"]
const _hoisted_59 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "52",
  height: "52",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M17.4417 14.62L20.0017 12.06L17.4417 9.5M9.76172 12.06H19.9317M11.7617 20C7.34172 20 3.76172 17 3.76172 12C3.76172 7 7.34172 4 11.7617 4",
    stroke: "#E1793E",
    "stroke-width": "1.5",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("h1", null, "Atenção!", -1)

import { computed, onMounted, ref } from 'vue'
import MySelect from '@/components/select/MySelect.vue'
import MyModal from '@/components/modal/MyModal.vue'
import { useAxios } from '@/api/axios'
import { AxiosResponse } from 'axios'
import { TenantModel } from '@/models/TenantModel'
import { TenantSectorEnum, tenantSectorLabels } from '@/enums/Tenants/TenantSectorEnum'
import { TenantModuleEnum, tenantModuleLabels } from '@/enums/Tenants/TenantModuleEnum'
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue'
import SpinnerLoaderButton from '@/components/loader/SpinnerLoaderButton.vue'
import { toast } from 'vue3-toastify'
import { storageUrl } from '@/global/states/GlobalState'

interface PermissionOption {
  id: number
  name: string
  label: string
}

interface TenantRole {
  id: number
  name: string
  permissions?: PermissionOption[]
}

interface TenantOrganization {
  id: number
  name: string
  acronym: string
}

interface TenantUser {
  id: number
  name: string
  last_name: string | null
  email: string
  status: string
  organization_id: number | null
  roles: TenantRole[]
  organization: { id: number; name: string } | null
}

interface TenantShowResponse {
  tenant: TenantModel
  roles: TenantRole[]
  organizations: TenantOrganization[]
  users: TenantUser[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EditTenantView',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props
const axios = useAxios()
const payload = ref<Partial<TenantModel>>({ modules: [] })
const logoPreview = ref<string>('')
const isUpdatingTenant = ref(false)
const roles = ref<TenantRole[]>()
const organizations = ref<TenantOrganization[]>()
const users = ref<TenantUser[]>()
const isAddingUser = ref(false)
const newUser = ref<{ name?: string, last_name?: string, email?: string, password?: string, role?: string, organizationId?: number, organizationName?: string }>({})
const canAddUser = computed(() => {
  return !!(newUser.value.name && newUser.value.last_name && newUser.value.email && newUser.value.password && newUser.value.password.length >= 6 && newUser.value.role)
})
const isConfirmImpersonateModal = ref(false)
const userToImpersonate = ref<TenantUser>()

const permissions = ref<PermissionOption[]>()
const newRole = ref<{ name?: string, permissionNames: string[] }>({ permissionNames: [] })
const isCreatingRole = ref(false)
const editingRoleId = ref<number>()
const editRolePayload = ref<{ name?: string, permissionNames: string[] }>({ permissionNames: [] })
const isSavingRole = ref(false)

onMounted(() => {
  fetchTenant()
  fetchPermissions()
})

function fetchTenant () {
  axios.get(`/api/platform-admin/tenants/${props.id}`)
    .then((res: AxiosResponse<TenantShowResponse>) => {
      payload.value = { ...res.data.tenant, modules: res.data.tenant.modules ?? [] }
      roles.value = res.data.roles
      organizations.value = res.data.organizations
      users.value = res.data.users
    })
}

function fetchPermissions () {
  axios.get('/api/platform-admin/permissions')
    .then((res: AxiosResponse<PermissionOption[]>) => {
      permissions.value = res.data
    })
}

function toggleNewRolePermission (name: string, checked: boolean) {
  const set = new Set(newRole.value.permissionNames)
  checked ? set.add(name) : set.delete(name)
  newRole.value.permissionNames = Array.from(set)
}

function createRole (): void {
  isCreatingRole.value = true

  const formData = new FormData()
  formData.append('name', newRole.value.name!)
  newRole.value.permissionNames.forEach((name, index) => {
    formData.append(`permissions[${index}]`, name)
  })

  axios.post(`/api/platform-admin/tenants/${props.id}/roles`, formData)
    .then(() => {
      toast.success('Perfil criado com sucesso')
      newRole.value = { permissionNames: [] }
      roles.value = undefined
      fetchTenant()
    })
    .finally(() => isCreatingRole.value = false)
}

function startEditRole (role: TenantRole) {
  editingRoleId.value = role.id
  editRolePayload.value = {
    name: role.name,
    permissionNames: (role.permissions ?? []).map((permission) => permission.name)
  }
}

function cancelRoleEdit () {
  editingRoleId.value = undefined
}

function toggleEditPermission (name: string, checked: boolean) {
  const set = new Set(editRolePayload.value.permissionNames)
  checked ? set.add(name) : set.delete(name)
  editRolePayload.value.permissionNames = Array.from(set)
}

function saveRoleEdit (roleId: number): void {
  isSavingRole.value = true

  const formData = new FormData()
  formData.append('name', editRolePayload.value.name!)
  formData.append('permissions_provided', '1')
  editRolePayload.value.permissionNames.forEach((name, index) => {
    formData.append(`permissions[${index}]`, name)
  })

  axios.patch(`/api/platform-admin/tenants/${props.id}/roles/${roleId}`, formData)
    .then(() => {
      toast.success('Perfil atualizado com sucesso')
      editingRoleId.value = undefined
      roles.value = undefined
      fetchTenant()
    })
    .finally(() => isSavingRole.value = false)
}

function addUser (): void {
  isAddingUser.value = true

  const formData = new FormData()
  formData.append('name', newUser.value.name!)
  formData.append('last_name', newUser.value.last_name!)
  formData.append('email', newUser.value.email!)
  formData.append('password', newUser.value.password!)
  formData.append('role', newUser.value.role!)
  if (newUser.value.organizationId) {
    formData.append('organization_id', String(newUser.value.organizationId))
  }

  axios.post(`/api/platform-admin/tenants/${props.id}/users`, formData)
    .then(() => {
      toast.success('Usuário adicionado com sucesso')
      newUser.value = {}
      users.value = undefined
      fetchTenant()
    })
    .finally(() => isAddingUser.value = false)
}

function impersonate (): void {
  if (!userToImpersonate.value) return

  axios.post(`/api/platform-admin/users/${userToImpersonate.value.id}/impersonate`)
    .then(() => {
      window.location.href = '/admin/home'
    })
}

function handleLogoChange (event: Event) {
  const input = event.target as HTMLInputElement
  const file: File | null = input.files && input.files[0]
  if (file) {
    payload.value.logo = file
    logoPreview.value = URL.createObjectURL(file)
  }
}

function toggleModule (module: TenantModuleEnum, checked: boolean) {
  const modules = new Set(payload.value.modules ?? [])
  if (checked) {
    modules.add(module)
  } else {
    modules.delete(module)
  }
  payload.value.modules = Array.from(modules)
}

function updateTenant (): void {
  isUpdatingTenant.value = true

  const formData = new FormData()
  formData.append('name', payload.value.name!)
  if (payload.value.acronym) {
    formData.append('acronym', payload.value.acronym)
  }
  formData.append('sector', payload.value.sector!)
  if (payload.value.logo instanceof File) {
    formData.append('logo', payload.value.logo)
  }
  formData.append('modules_provided', '1')
  const modules = payload.value.modules ?? []
  modules.forEach((module, index) => {
    formData.append(`modules[${index}]`, module)
  })

  axios.patch(`/api/platform-admin/tenants/${props.id}`, formData)
    .then((res: AxiosResponse<TenantModel>) => {
      payload.value = { ...res.data, modules: res.data.modules ?? [] }
      logoPreview.value = ''
      toast.success('Tenant editado com sucesso')
    })
    .finally(() => isUpdatingTenant.value = false)
}

return (_ctx: any,_cache: any) => {
  return (payload.value.id)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("label", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'platform-admin.tenants.index' }))),
          class: "back"
        }, _hoisted_4),
        _createElementVNode("section", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", {
            class: _normalizeClass(["data", { 'nophoto': !logoPreview.value && !payload.value.logo }])
          }, [
            _createElementVNode("div", {
              style: _normalizeStyle({ backgroundImage: 'url(' + (logoPreview.value ? logoPreview.value : (payload.value.logo ? _unref(storageUrl) + payload.value.logo : '')) + ')' })
            }, _hoisted_8, 4),
            _createElementVNode("input", {
              autocomplete: "off",
              type: "file",
              accept: "image/*",
              name: "tenant-logo",
              id: "tenant-logo",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (handleLogoChange($event)))
            }, null, 32),
            _hoisted_9
          ], 2)
        ]),
        _createElementVNode("section", _hoisted_10, [
          _createElementVNode("section", null, [
            _hoisted_11,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Ex: Prefeitura de Canindé",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.name) = $event))
            }, null, 512), [
              [_vModelText, payload.value.name]
            ])
          ]),
          _createElementVNode("section", null, [
            _hoisted_12,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Ex: P.M.C",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((payload.value.acronym) = $event))
            }, null, 512), [
              [_vModelText, payload.value.acronym]
            ])
          ])
        ]),
        _createElementVNode("section", null, [
          _hoisted_13,
          _createVNode(MySelect, {
            name: 'sector',
            for: 'sector',
            currentValue: payload.value.sector ? _unref(tenantSectorLabels)[payload.value.sector] : null
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(_unref(TenantSectorEnum)), (sector) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: sector,
                  onMousedown: ($event: any) => (payload.value.sector = sector)
                }, _toDisplayString(_unref(tenantSectorLabels)[sector]), 41, _hoisted_14))
              }), 128))
            ]),
            _: 1
          }, 8, ["currentValue"])
        ]),
        _createElementVNode("section", _hoisted_15, [
          _hoisted_16,
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(_unref(TenantModuleEnum)), (module) => {
              return (_openBlock(), _createElementBlock("label", {
                class: "module-toggle",
                key: module
              }, [
                _createElementVNode("input", {
                  type: "checkbox",
                  checked: payload.value.modules?.includes(module),
                  onChange: ($event: any) => (toggleModule(module, ($event.target as HTMLInputElement).checked))
                }, null, 40, _hoisted_19),
                _hoisted_20,
                _createElementVNode("p", null, _toDisplayString(_unref(tenantModuleLabels)[module]), 1)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("section", _hoisted_21, [
          _hoisted_22,
          _hoisted_23,
          (roles.value?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roles.value, (role) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "role-card",
                    key: role.id
                  }, [
                    (editingRoleId.value !== role.id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _createElementVNode("div", null, [
                            _createElementVNode("h1", null, _toDisplayString(role.name), 1),
                            _createElementVNode("h2", null, _toDisplayString(role.permissions?.length ?? 0) + " permissões", 1)
                          ]),
                          _createElementVNode("button", {
                            class: "tooltip",
                            onClick: ($event: any) => (startEditRole(role))
                          }, _hoisted_28, 8, _hoisted_26)
                        ]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("section", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              placeholder: "Nome do perfil",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((editRolePayload.value.name) = $event))
                            }, null, 512), [
                              [_vModelText, editRolePayload.value.name]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permissions.value, (permission) => {
                              return (_openBlock(), _createElementBlock("label", {
                                class: "permission-chip",
                                key: permission.id
                              }, [
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  checked: editRolePayload.value.permissionNames.includes(permission.name),
                                  onChange: ($event: any) => (toggleEditPermission(permission.name, ($event.target as HTMLInputElement).checked))
                                }, null, 40, _hoisted_30),
                                _hoisted_31,
                                _createElementVNode("p", null, _toDisplayString(permission.label), 1)
                              ]))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            (!isSavingRole.value)
                              ? (_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  type: "button",
                                  value: "Salvar",
                                  disabled: !editRolePayload.value.name,
                                  onClick: ($event: any) => (saveRoleEdit(role.id))
                                }, null, 8, _hoisted_33))
                              : (_openBlock(), _createBlock(SpinnerLoaderButton, {
                                  key: 1,
                                  height: 44,
                                  maxWidth: 140
                                })),
                            _createElementVNode("button", {
                              class: "cancel",
                              onClick: cancelRoleEdit
                            }, "Cancelar")
                          ])
                        ], 64))
                  ]))
                }), 128))
              ]))
            : (roles.value)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_34, "Nenhum perfil cadastrado ainda."))
              : (_openBlock(), _createBlock(SpinnerLoader, { key: 2 })),
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("section", null, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "Nome do perfil",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((newRole.value.name) = $event))
              }, null, 512), [
                [_vModelText, newRole.value.name]
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permissions.value, (permission) => {
                return (_openBlock(), _createElementBlock("label", {
                  class: "permission-chip",
                  key: permission.id
                }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: newRole.value.permissionNames.includes(permission.name),
                    onChange: ($event: any) => (toggleNewRolePermission(permission.name, ($event.target as HTMLInputElement).checked))
                  }, null, 40, _hoisted_38),
                  _hoisted_39,
                  _createElementVNode("p", null, _toDisplayString(permission.label), 1)
                ]))
              }), 128))
            ]),
            (!isCreatingRole.value)
              ? (_openBlock(), _createElementBlock("input", {
                  key: 0,
                  type: "button",
                  value: "Criar perfil",
                  disabled: !newRole.value.name,
                  onClick: createRole
                }, null, 8, _hoisted_40))
              : (_openBlock(), _createBlock(SpinnerLoaderButton, {
                  key: 1,
                  height: 55,
                  maxWidth: 220
                }))
          ])
        ]),
        _createElementVNode("section", _hoisted_41, [
          _hoisted_42,
          (users.value?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (tenantUser) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "user-row doc-grid",
                    key: tenantUser.id
                  }, [
                    _createElementVNode("label", _hoisted_44, [
                      _createElementVNode("h1", null, _toDisplayString(tenantUser.name) + " " + _toDisplayString(tenantUser.last_name ?? ''), 1),
                      _createElementVNode("h2", null, _toDisplayString(tenantUser.email), 1)
                    ]),
                    _createElementVNode("label", null, [
                      _createElementVNode("h1", null, _toDisplayString(tenantUser.roles[0]?.name ?? 'Sem role'), 1)
                    ]),
                    _createElementVNode("label", null, [
                      _createElementVNode("h1", null, _toDisplayString(tenantUser.organization?.name ?? 'Sem organização'), 1)
                    ]),
                    _createElementVNode("label", _hoisted_45, [
                      _createElementVNode("button", {
                        class: "tooltip",
                        onClick: ($event: any) => {userToImpersonate.value = tenantUser; isConfirmImpersonateModal.value = true}
                      }, _hoisted_48, 8, _hoisted_46)
                    ])
                  ]))
                }), 128))
              ]))
            : (users.value)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_49, "Nenhum usuário cadastrado ainda."))
              : (_openBlock(), _createBlock(SpinnerLoader, { key: 2 })),
          _createElementVNode("div", _hoisted_50, [
            _hoisted_51,
            _createElementVNode("section", _hoisted_52, [
              _createElementVNode("section", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "Nome",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((newUser.value.name) = $event))
                }, null, 512), [
                  [_vModelText, newUser.value.name]
                ])
              ]),
              _createElementVNode("section", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "Sobrenome",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((newUser.value.last_name) = $event))
                }, null, 512), [
                  [_vModelText, newUser.value.last_name]
                ])
              ])
            ]),
            _createElementVNode("section", _hoisted_53, [
              _createElementVNode("section", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "E-mail",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((newUser.value.email) = $event))
                }, null, 512), [
                  [_vModelText, newUser.value.email]
                ])
              ]),
              _createElementVNode("section", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "Senha (mín. 6 caracteres)",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((newUser.value.password) = $event))
                }, null, 512), [
                  [_vModelText, newUser.value.password]
                ])
              ])
            ]),
            _createElementVNode("section", _hoisted_54, [
              _createElementVNode("section", null, [
                (roles.value)
                  ? (_openBlock(), _createBlock(MySelect, {
                      key: 0,
                      name: 'new-user-role',
                      for: 'new-user-role',
                      currentValue: newUser.value.role ?? null
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roles.value, (role) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: role.id,
                            onMousedown: ($event: any) => (newUser.value.role = role.name)
                          }, _toDisplayString(role.name), 41, _hoisted_55))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["currentValue"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("section", null, [
                (organizations.value)
                  ? (_openBlock(), _createBlock(MySelect, {
                      key: 0,
                      name: 'new-user-organization',
                      for: 'new-user-organization',
                      currentValue: newUser.value.organizationName ?? 'Nenhuma'
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("li", {
                          onMousedown: _cache[10] || (_cache[10] = ($event: any) => {newUser.value.organizationId = undefined; newUser.value.organizationName = 'Nenhuma'})
                        }, "Nenhuma", 32),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, (organization) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: organization.id,
                            onMousedown: ($event: any) => {newUser.value.organizationId = organization.id; newUser.value.organizationName = organization.name}
                          }, _toDisplayString(organization.name), 41, _hoisted_56))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["currentValue"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (!isAddingUser.value)
              ? (_openBlock(), _createElementBlock("input", {
                  key: 0,
                  type: "button",
                  value: "Adicionar usuário",
                  disabled: !canAddUser.value,
                  onClick: addUser
                }, null, 8, _hoisted_57))
              : (_openBlock(), _createBlock(SpinnerLoaderButton, {
                  key: 1,
                  height: 55,
                  maxWidth: 220
                }))
          ])
        ]),
        _createElementVNode("nav", null, [
          (!isUpdatingTenant.value)
            ? (_openBlock(), _createElementBlock("input", {
                key: 0,
                type: "button",
                value: "Salvar",
                disabled: !payload.value.name || !payload.value.sector,
                onClick: updateTenant
              }, null, 8, _hoisted_58))
            : (_openBlock(), _createBlock(SpinnerLoaderButton, {
                key: 1,
                height: 60,
                maxWidth: 464
              })),
          _createElementVNode("input", {
            type: "button",
            value: "Cancelar",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$router.push({ name: 'platform-admin.tenants.index' })))
          })
        ]),
        _createVNode(MyModal, {
          width: '360px !important',
          height: '320px !important',
          isOpen: isConfirmImpersonateModal.value,
          "class-name": 'confirm-impersonate',
          toggleModal: (v) => isConfirmImpersonateModal.value = v,
          zIndex: 100
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _hoisted_59,
              _hoisted_60,
              _createElementVNode("h2", null, [
                _createTextVNode("Você vai entrar como "),
                _createElementVNode("strong", null, _toDisplayString(userToImpersonate.value?.name) + " " + _toDisplayString(userToImpersonate.value?.last_name), 1),
                _createTextVNode(" (" + _toDisplayString(userToImpersonate.value?.email) + "). Essa ação fica registrada.", 1)
              ]),
              _createElementVNode("section", null, [
                _createElementVNode("button", {
                  onClick: _cache[12] || (_cache[12] = ($event: any) => {isConfirmImpersonateModal.value = false; impersonate()})
                }, "Sim, entrar"),
                _createElementVNode("input", {
                  autocomplete: "off",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (isConfirmImpersonateModal.value = false)),
                  type: "button",
                  value: "Cancelar"
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["isOpen", "toggleModal"])
      ]))
    : (_openBlock(), _createBlock(SpinnerLoader, { key: 1 }))
}
}

})